import { StorageFacade } from './storageFacade';

const localStorage = new StorageFacade(window.localStorage);
export { localStorage }


// WEBPACK FOOTER //
// ./src/common/storage/index.js